// AuraFlex — script.js

// ---- Announce bar rotator ----
const announceMsgs = document.querySelectorAll('.announce-msg');
let announceIdx = 0;
if (announceMsgs.length > 1) {
  setInterval(() => {
    announceMsgs[announceIdx].classList.remove('active');
    announceIdx = (announceIdx + 1) % announceMsgs.length;
    announceMsgs[announceIdx].classList.add('active');
  }, 3500);
}

// ---- Navbar scroll shadow ----
const nav = document.getElementById('nav');
window.addEventListener('scroll', () => {
  nav?.classList.toggle('scrolled', window.scrollY > 40);
}, { passive: true });

// ---- Sticky bar ----
const stickyBar = document.getElementById('stickyBar');
window.addEventListener('scroll', () => {
  if (!stickyBar) return;
  stickyBar.style.display = window.scrollY > 700 ? 'block' : 'none';
}, { passive: true });

// ---- FAQ accordion ----
function toggleFaq(btn) {
  const answer = btn.nextElementSibling;
  const isOpen = btn.classList.contains('open');
  document.querySelectorAll('.faq-q').forEach(q => {
    q.classList.remove('open');
    q.nextElementSibling.style.maxHeight = null;
  });
  if (!isOpen) {
    btn.classList.add('open');
    answer.style.maxHeight = answer.scrollHeight + 'px';
  }
}

// ---- Thumbnail switcher ----
function switchImg(thumb, src) {
  const main = document.getElementById('buyMainImg');
  if (main) main.src = src;
  document.querySelectorAll('.buy-thumb').forEach(t => t.classList.remove('active'));
  thumb.classList.add('active');
}

// ---- Shopify cart config ----
const SHOPIFY = {
  store: 'auraflex-11.myshopify.com',
  variants: { '1': '43160459804777', '2': '43160466391145', '3': '43160466423913' }
};
function shopifyCartURL(qty) {
  return `https://${SHOPIFY.store}/cart/${SHOPIFY.variants[qty]}:1`;
}

// ---- Bundle prices ----
const prices = { '1': '$34.99', '2': '$59.99', '3': '$79.99' };
const bundleData = {
  '1': { now: '$34.99', was: '$59.99', save: 'Save $25 · 40% Off' },
  '2': { now: '$59.99', was: '$99.99', save: 'Save $40 · 40% Off' },
  '3': { now: '$79.99', was: '$129.99', save: 'Save $50 · 38% Off' },
};

// Update price display + cart button when bundle changes
document.addEventListener('change', (e) => {
  if (e.target.name !== 'qty') return;
  const d = bundleData[e.target.value];

  const nowEl  = document.getElementById('pdpNow');
  const wasEl  = document.getElementById('pdpWas');
  const saveEl = document.getElementById('pdpSave');

  if (nowEl) {
    nowEl.textContent = d.now;
    nowEl.classList.add('price-flash');
    setTimeout(() => nowEl.classList.remove('price-flash'), 400);
  }
  if (wasEl)  wasEl.textContent  = d.was;
  if (saveEl) saveEl.textContent = d.save;

  const stickyNow = document.getElementById('stickyNow');
  const stickyWas = document.getElementById('stickyWas');
  if (stickyNow) stickyNow.textContent = d.now;
  if (stickyWas) stickyWas.textContent = d.was;

  document.querySelectorAll('.btn-cart').forEach(btn => {
    if (!btn.classList.contains('sticky-btn')) {
      btn.textContent = `Add to Cart — ${d.now} →`;
    }
  });
});

// ---- Sticky Buy Now ----
function handleStickyBuy() {
  const selected = document.querySelector('input[name="qty"]:checked');
  const qty = selected ? selected.value : '2';
  window.location.href = shopifyCartURL(qty);
}

// ---- Add to cart ----
function handleBuy() {
  const selected = document.querySelector('input[name="qty"]:checked');
  const qty = selected ? selected.value : '2';
  window.location.href = shopifyCartURL(qty);
}

// ---- Toast ----
function showToast(msg) {
  let toast = document.getElementById('toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'toast';
    toast.id = 'toast';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.classList.add('show');
  setTimeout(() => toast.classList.remove('show'), 3500);
}

// ---- Stock countdown ----
const STOCK_MAX = 2000;
let stock = 1200;
const updateStock = () => {
  ['stock-count','stock-count-2','stock-count-3','stock-count-sticky'].forEach(id => {
    const el = document.getElementById(id);
    if (el) {
      el.textContent = stock;
      el.style.color = '#EF4444';
      setTimeout(() => el.style.color = '', 600);
    }
  });
  const bar = document.getElementById('stockBarFill');
  if (bar) bar.style.width = Math.max(4, (stock / STOCK_MAX) * 100) + '%';
};

// Slowly drain the bar visually every 20s even without stock drop
setInterval(() => {
  const bar = document.getElementById('stockBarFill');
  if (!bar) return;
  const current = parseFloat(bar.style.width);
  if (current > 8) bar.style.width = (current - 0.4) + '%';
}, 20000);
setInterval(() => {
  if (stock > 4 && Math.random() < 0.3) { stock--; updateStock(); }
}, 45000);

// ---- Viewer + sold counter ----
let viewers = Math.floor(Math.random() * 18) + 38; // 38–55
let sold    = Math.floor(Math.random() * 12) + 12;  // 12–23
const viewEl = document.getElementById('viewerCount');
const soldEl = document.getElementById('soldCount');
if (viewEl) viewEl.textContent = viewers;
if (soldEl) soldEl.textContent = sold;

setInterval(() => {
  const delta = Math.random() < 0.5 ? 1 : -1;
  viewers = Math.max(28, Math.min(71, viewers + delta));
  if (viewEl) {
    viewEl.textContent = viewers;
    viewEl.style.color = '#22D3EE';
    setTimeout(() => viewEl.style.color = '', 500);
  }
}, 7000);

setInterval(() => {
  if (Math.random() < 0.4) {
    sold++;
    if (soldEl) {
      soldEl.textContent = sold;
      soldEl.style.fontWeight = '800';
      setTimeout(() => soldEl.style.fontWeight = '', 600);
    }
  }
}, 30000);

// ---- FOMO notifications ----
const fomoNames = [
  { name: 'Sarah',      city: 'New York',        initial: 'S' },
  { name: 'James',      city: 'Austin',          initial: 'J' },
  { name: 'Priya',      city: 'Chicago',         initial: 'P' },
  { name: 'Mike',       city: 'Los Angeles',     initial: 'M' },
  { name: 'Lily',       city: 'Seattle',         initial: 'L' },
  { name: 'Carlos',     city: 'Miami',           initial: 'C' },
  { name: 'Ashley',     city: 'Dallas',          initial: 'A' },
  { name: 'Jordan',     city: 'Phoenix',         initial: 'J' },
  { name: 'Rachel',     city: 'Boston',          initial: 'R' },
  { name: 'David',      city: 'Denver',          initial: 'D' },
  { name: 'Emma',       city: 'Nashville',       initial: 'E' },
  { name: 'Tyler',      city: 'Portland',        initial: 'T' },
  { name: 'Mia',        city: 'San Diego',       initial: 'M' },
  { name: 'Brandon',    city: 'Atlanta',         initial: 'B' },
  { name: 'Sofia',      city: 'Houston',         initial: 'S' },
  { name: 'Kevin',      city: 'Charlotte',       initial: 'K' },
  { name: 'Hannah',     city: 'Minneapolis',     initial: 'H' },
  { name: 'Ethan',      city: 'San Francisco',   initial: 'E' },
  { name: 'Olivia',     city: 'Philadelphia',    initial: 'O' },
  { name: 'Marcus',     city: 'Las Vegas',       initial: 'M' },
  { name: 'Chloe',      city: 'San Jose',        initial: 'C' },
  { name: 'Nathan',     city: 'Columbus',        initial: 'N' },
  { name: 'Zoe',        city: 'Indianapolis',    initial: 'Z' },
  { name: 'Derek',      city: 'Jacksonville',    initial: 'D' },
  { name: 'Amber',      city: 'Fort Worth',      initial: 'A' },
  { name: 'Ryan',       city: 'Memphis',         initial: 'R' },
  { name: 'Jasmine',    city: 'Baltimore',       initial: 'J' },
  { name: 'Connor',     city: 'Louisville',      initial: 'C' },
  { name: 'Brianna',    city: 'Milwaukee',       initial: 'B' },
  { name: 'Xavier',     city: 'Albuquerque',     initial: 'X' },
  { name: 'Natalie',    city: 'Tucson',          initial: 'N' },
  { name: 'Logan',      city: 'Fresno',          initial: 'L' },
  { name: 'Stephanie',  city: 'Sacramento',      initial: 'S' },
  { name: 'Aaron',      city: 'Mesa',            initial: 'A' },
  { name: 'Kayla',      city: 'Kansas City',     initial: 'K' },
  { name: 'Justin',     city: 'Omaha',           initial: 'J' },
  { name: 'Vanessa',    city: 'Raleigh',         initial: 'V' },
  { name: 'Patrick',    city: 'Colorado Springs',initial: 'P' },
  { name: 'Danielle',   city: 'Virginia Beach',  initial: 'D' },
  { name: 'Trevor',     city: 'Long Beach',      initial: 'T' },
  { name: 'Monica',     city: 'Tampa',           initial: 'M' },
  { name: 'Cole',       city: 'New Orleans',     initial: 'C' },
  { name: 'Alexis',     city: 'Cleveland',       initial: 'A' },
  { name: 'Sean',       city: 'Bakersfield',     initial: 'S' },
  { name: 'Tiffany',    city: 'Aurora',          initial: 'T' },
  { name: 'Kyle',       city: 'Anaheim',         initial: 'K' },
  { name: 'Melissa',    city: 'Corpus Christi',  initial: 'M' },
  { name: 'Ian',        city: 'Riverside',       initial: 'I' },
  { name: 'Amber',      city: 'St. Louis',       initial: 'A' },
  { name: 'Drew',       city: 'Pittsburgh',      initial: 'D' },
  { name: 'Lauren',     city: 'Anchorage',       initial: 'L' },
  { name: 'Chase',      city: 'Stockton',        initial: 'C' },
  { name: 'Hailey',     city: 'Cincinnati',      initial: 'H' },
  { name: 'Garrett',    city: 'St. Paul',        initial: 'G' },
  { name: 'Whitney',    city: 'Toledo',          initial: 'W' },
  { name: 'Blake',      city: 'Greensboro',      initial: 'B' },
  { name: 'Samantha',   city: 'Newark',          initial: 'S' },
  { name: 'Evan',       city: 'Plano',           initial: 'E' },
  { name: 'Paige',      city: 'Henderson',       initial: 'P' },
  { name: 'Jared',      city: 'Lincoln',         initial: 'J' },
  { name: 'Crystal',    city: 'Buffalo',         initial: 'C' },
  { name: 'Spencer',    city: 'Fort Wayne',      initial: 'S' },
  { name: 'Brittany',   city: 'Jersey City',     initial: 'B' },
  { name: 'Caleb',      city: 'Chula Vista',     initial: 'C' },
  { name: 'Faith',      city: 'Orlando',         initial: 'F' },
  { name: 'Tanner',     city: 'St. Petersburg',  initial: 'T' },
  { name: 'Destiny',    city: 'Laredo',          initial: 'D' },
  { name: 'Hunter',     city: 'Madison',         initial: 'H' },
  { name: 'Sierra',     city: 'Durham',          initial: 'S' },
  { name: 'Austin',     city: 'Lubbock',         initial: 'A' },
  { name: 'Shelby',     city: 'Winston-Salem',   initial: 'S' },
  { name: 'Bryce',      city: 'Garland',         initial: 'B' },
  { name: 'Courtney',   city: 'Glendale',        initial: 'C' },
  { name: 'Wyatt',      city: 'Hialeah',         initial: 'W' },
  { name: 'Marissa',    city: 'Reno',            initial: 'M' },
  { name: 'Dominic',    city: 'Baton Rouge',     initial: 'D' },
  { name: 'Kelsey',     city: 'Irvine',          initial: 'K' },
  { name: 'Grant',      city: 'Chesapeake',      initial: 'G' },
  { name: 'Allison',    city: 'Irving',          initial: 'A' },
  { name: 'Dillon',     city: 'Scottsdale',      initial: 'D' },
  { name: 'Haley',      city: 'Fremont',         initial: 'H' },
  { name: 'Jenna',      city: 'Gilbert',         initial: 'J' },
  { name: 'Tristan',    city: 'Birmingham',      initial: 'T' },
  { name: 'Leah',       city: 'Rochester',       initial: 'L' },
  { name: 'Colton',     city: 'Richmond',        initial: 'C' },
  { name: 'Brooke',     city: 'Spokane',         initial: 'B' },
  { name: 'Wesley',     city: 'Des Moines',      initial: 'W' },
  { name: 'Sabrina',    city: 'Montgomery',      initial: 'S' },
  { name: 'Dalton',     city: 'Tacoma',          initial: 'D' },
  { name: 'Cassidy',    city: 'Akron',           initial: 'C' },
  { name: 'Reid',       city: 'Little Rock',     initial: 'R' },
  { name: 'Autumn',     city: 'Huntsville',      initial: 'A' },
  { name: 'Marco',      city: 'Grand Rapids',    initial: 'M' },
  { name: 'Isabel',     city: 'Salt Lake City',  initial: 'I' },
  { name: 'Gavin',      city: 'Tallahassee',     initial: 'G' },
  { name: 'Peyton',     city: 'Huntington Beach',initial: 'P' },
  { name: 'Victor',     city: 'Knoxville',       initial: 'V' },
  { name: 'Jade',       city: 'Worcester',       initial: 'J' },
  { name: 'Lance',      city: 'Brownsville',     initial: 'L' },
];

let fomoLastIdx = -1;
function getNextFomo() {
  let idx;
  do { idx = Math.floor(Math.random() * fomoNames.length); } while (idx === fomoLastIdx);
  fomoLastIdx = idx;
  return { ...fomoNames[idx], qty: Math.random() < 0.4 ? 1 : Math.random() < 0.7 ? 2 : 3 };
}

function showFomo() {
  const { name, city, initial, qty } = getNextFomo();
  const toast = document.getElementById('fomoToast');
  const av    = document.getElementById('fomoAv');
  const nm    = document.getElementById('fomoName');
  const msg   = document.getElementById('fomoMsg');
  if (!toast || !av || !nm || !msg) return;
  av.textContent  = initial;
  nm.textContent  = `${name} from ${city}`;
  msg.textContent = `just ordered ${qty}× AuraFlex · moments ago`;
  toast.classList.add('show');
  setTimeout(() => toast.classList.remove('show'), 5000);

  stock = Math.max(0, stock - qty);
  if (stock < 10) stock = 2000;
  updateStock();

  sold += qty;
  if (soldEl) {
    soldEl.textContent = sold;
    soldEl.style.fontWeight = '800';
    setTimeout(() => soldEl.style.fontWeight = '', 600);
  }
}

// Fire first few on fixed delays, then repeat every 18–30s forever
[8000, 22000, 40000, 58000, 75000].forEach(delay => setTimeout(showFomo, delay));
setInterval(showFomo, 22000);

// ---- Track Order modal ----
function openTracker() {
  document.getElementById('trackerOverlay').classList.add('open');
  document.getElementById('trackerModal').classList.add('open');
  setTimeout(() => document.getElementById('trackingInput').focus(), 100);
}
function closeTracker() {
  document.getElementById('trackerOverlay').classList.remove('open');
  document.getElementById('trackerModal').classList.remove('open');
}
function trackOrder() {
  const num = document.getElementById('trackingInput').value.trim();
  if (!num) {
    document.getElementById('trackingInput').style.borderColor = '#EF4444';
    setTimeout(() => document.getElementById('trackingInput').style.borderColor = '', 1500);
    return;
  }
  window.open(`https://t.17track.net/en#nums=${encodeURIComponent(num)}`, '_blank');
}
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') closeTracker();
  if (e.key === 'Enter' && document.getElementById('trackerModal').classList.contains('open')) trackOrder();
});

// ---- Scroll reveal ----
const revealEls = document.querySelectorAll(
  '.rv-card, .how-step, .feat-list li, .faq-item, .pstat, .cond-card, .tl-card'
);
const io = new IntersectionObserver((entries) => {
  entries.forEach((entry, i) => {
    if (entry.isIntersecting) {
      setTimeout(() => {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }, i * 60);
      io.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

revealEls.forEach(el => {
  el.style.opacity = '0';
  el.style.transform = 'translateY(18px)';
  el.style.transition = 'opacity .55s ease, transform .55s ease';
  io.observe(el);
});
